import { useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import {
  TCreateFormConfigPaylod,
  useAlreadyCreatedFormConfigs,
  useCreateFormConfig,
} from "../../../hooks/form-step-config.hooks";
import { useServiceTypes } from "../../../hooks/forms.hooks";
import StepConfigForm from "./Form";

export function AddStepConfig() {
  const { isFetching, isError } = useServiceTypes();
  const { isFetching: isFetching1, isError: isError1 } =
    useAlreadyCreatedFormConfigs();
  const { mutate } = useCreateFormConfig();
  const navigate = useNavigate();

  const onSubmit = (payload: TCreateFormConfigPaylod) => {
    mutate(payload, {
      onSuccess: () => navigate("/step-configurations", { replace: true }),
    });
  };

  let toRender = null;
  if (isFetching || isFetching1 || isError || isError1) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError || isError1 ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else {
    toRender = (
      <StepConfigForm
        ctx="add"
        onSubmit={onSubmit}
        defaultValues={{ active: true, serviceName: "", selectedForms: [] }}
      />
    );
  }

  return <div>{toRender}</div>;
}
